
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiApiGrid extends Serenity.EntityGrid<UtentiApiRow, any> {
        protected getColumnsKey() { return UtentiApiColumns.columnsKey; }
        protected getDialogType() { return UtentiApiDialog; }
        protected getIdProperty() { return UtentiApiRow.idProperty; }
        protected getInsertPermission() { return UtentiApiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiApiRow.localTextPrefix; }
        protected getService() { return UtentiApiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}